<template>
    <div class="loading-spinner" v-if="this.$store.state.loading">
        <h1 class="loading-text"> {{$t('txt.loading')}}  </h1>
        <div class="wavecontainer">
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>
